module.exports = __webpack_public_path__ + "static/media/philbox-img03.83273162.jpg";